// src/themes/lightTheme.js
import { createTheme } from '@mui/material/styles';

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    background: {
      default: '#f4f6f8',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // Explicit light color-scheme so native scrollbars/form controls stay
        // light even if the OS is set to dark mode.
        ':root': { colorScheme: 'light' },
      },
    },
  },
});

export default lightTheme;
